<template>
  <div class="experiences" id="experiences">
    <DirectionArrows :position="$props.position" :count="$props.count" :sidebar="$props.sidebar"/>

    <HelloWorld msg="Experiences"/>
      <div class="experiences-container">
          <div class="experience">
              <img src="img/logo_perso.png" alt="">
              <div class="experience-details">
                  <h3>Développeur Web Fullstack</h3>
                  <span>Wiboo</span>
                  <span>Alternance - 2 ans</span>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam,
                      amet animi aperiam asperiores autem consectetur corporis dolore ducimus
                      et ipsa laborum, magni maxime neque nobis nulla numquam odio, quod vel!</p>
                  <span class="date">2019 - 2021</span>
              </div>
          </div>
           <div class="experience">
              <img src="img/logo_perso.png" alt="">
              <div class="experience-details">
                  <h3>Développeur Web</h3>
                <span>Le Monde Change</span>
                <span>Alternance - 1 an</span>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam,
                      amet animi aperiam asperiores autem consectetur corporis dolore ducimus
                      et ipsa laborum, magni maxime neque nobis nulla numquam odio, quod vel!</p>
                  <span class="date">2018</span>
              </div>
          </div>
           <div class="experience">
              <img src="img/logo_perso.png" alt="">
              <div class="experience-details">
                  <h3>Développeur Web</h3>
                <span>Le Monde Change</span>
                <span>Mission Freelance - 2 jours</span>
                  <p>Adapter un thème angular pour un site d'un client avec data en brut.</p>
                  <span class="date">2017</span>
              </div>
          </div>
        <div class="experience">
              <img src="img/logo_perso.png" alt="">
              <div class="experience-details">
                  <h3>Développeur Web</h3>
                <span>Le Monde Change</span>
                <span>Stage - 6 semaines</span>
                  <ul>
                    <li>Maintenance sur des sites Wordpress</li>
                    <li>Administration de base de données mysql</li>
                    <li>Débug de base de données mysql</li>
                  </ul>
                  <span class="date">2017</span>
              </div>
          </div>

      </div>
  </div>
</template>
<script>
  // @ is an alias to /src
  import HelloWorld from '@/components/HelloWorld.vue'
  import DirectionArrows from '@/components/ArrowsDirection.vue'

  export default {
    name: 'Experiences',
    props:['position','sidebar','count'],

    components: {
      HelloWorld,
      DirectionArrows
    }
  }
</script>
<style >

    .experiences-container{
        display: flex;
        flex-direction: column;
        width: 100%;
        height: inherit;
        overflow:auto;
        padding-right:20px;
    }
    .experience{
        position: relative;
        padding:5px 10px;
        align-items: center;
        display: flex;
        margin:10px 0;
        background: rgba(1, 7, 20, 0.31);
      transition: .3s;

    }
    .experience img{
        width: 180px;
        height: 180px;
    }
    .experience .experience-details{
        text-align: left;
        padding:10px;
    }
    .experience .experience-details h3{
        text-transform: uppercase;
        margin-top: 0;
        letter-spacing: 3px;
    }
    .experience .experience-details span.date{
        position: absolute;
        top:20px;
        right:10px;
    }
    #experiences{
        height: 80%;
        width: 40%;
        order:3;
    }
    /* width */
    .experiences-container::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    .experiences-container::-webkit-scrollbar-track {
        background: rgba(1, 7, 20, 0.31);
    }

    /* Handle */
    .experiences-container::-webkit-scrollbar-thumb {
        background: #fff;
    }

    /* Handle on hover */
    .experiences-container::-webkit-scrollbar-thumb:hover {
    }
</style>
